import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Projects from './components/sections/Projects';
import Skills from './components/sections/Skills';
import Pricing from './components/sections/Pricing';
import FAQ from './components/sections/FAQ';
import Contact from './components/sections/Contact';
import Footer from './components/layout/Footer';
import WhatsAppButton from './components/layout/WhatsAppButton';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import CookiePolicy from './components/pages/CookiePolicy';
import TermsConditions from './components/pages/TermsConditions';
import AccessibilityStatement from './components/pages/AccessibilityStatement';
import RefundCancellationPolicy from './components/pages/RefundCancellationPolicy';
import DataProcessingAgreement from './components/pages/DataProcessingAgreement';
import './styles/global.css';
import './styles/mobile.css'; // Import our mobile-specific enhancements
import './App.css';

// Main homepage component
const HomePage = () => (
  <main>
    <Hero />
    <About />
    <Projects />
    <Skills />
    <Pricing />
    <FAQ />
    <Contact />
  </main>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          <Route path="/refund-policy" element={<RefundCancellationPolicy />} />
          <Route path="/data-processing" element={<DataProcessingAgreement />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
